import { render } from "./EditWidget.vue?vue&type=template&id=e8923552&ts=true"
import script from "./EditWidget.vue?vue&type=script&lang=ts"
export * from "./EditWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__